import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import MfaQrCode from './MfaQrCode';
import MfaInputForm from './MfaInputForm';
import { AppDispatch, AppState } from '@/redux/root';
import { useDispatch, useSelector } from 'react-redux';
import { otpCodeSubmit } from '@/redux/slices/auth';

const MfaActivateForm = () => {
  const [step, setStep] = useState<'qr' | 'verify'>('qr');
  const dispatch = useDispatch<AppDispatch>();

  // RTK Query hooks
  const { qrCode, totpSecret } = useSelector((state: AppState) => state.auth);

  const handleCodeSubmit = async (code: string) => {
    try {
      dispatch(otpCodeSubmit(code));
    } catch (err) {
      console.error('Failed to enable TOTP:', err);
    }
  };

  const handleNextStep = () => {
    setStep('verify');
  };

  return (
    <Modal isOpen centered>
      <ModalHeader>Set Up Two-Factor Authentication</ModalHeader>
      <ModalBody>
        {step === 'qr' && qrCode && <MfaQrCode qrCode={qrCode} secret={totpSecret} onNext={handleNextStep} />}

        {step === 'verify' && <MfaInputForm onSubmit={handleCodeSubmit} onBack={() => setStep('qr')} />}
      </ModalBody>
    </Modal>
  );
};

export default MfaActivateForm;
